module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./markdown.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/markdown.md
// module id = APJW
// module chunks = 0